export var ClientType;

(function (ClientType) {
  ClientType[ClientType["contratante"] = 0] = "contratante";
  ClientType[ClientType["asegurado"] = 1] = "asegurado";
  ClientType[ClientType["beneficiario"] = 2] = "beneficiario";
})(ClientType || (ClientType = {}));

export var CLAIM_DOCUMENT_TYPES = [{
  value: "ClaimDocuments::CompanyClaim",
  label: "Denuncia Compañía"
}, {
  value: "ClaimDocuments::ClientRecord",
  label: "Antecedente cliente"
}, {
  value: "ClaimDocuments::LiquidationReport",
  label: "Informe liquidación"
}, {
  value: "ClaimDocuments::Settlement",
  label: "Finiquito"
}, {
  value: "ClaimDocuments::IncidentImage",
  label: "Imagenes Siniestro"
}];
export var statusActions = {
  ok: "ok",
  error: "error"
};